import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Higher Order Component para adicionar hooks do React Router v6 em componentes de classe
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        // Compatibilidade com v5
        location={location}
        navigate={navigate}
        params={params}
        history={{ 
          push: (pathOrObject, deprecatedState) => {
            // Suporta tanto history.push('/path', state) quanto history.push({ pathname: '/path', state: {...} })
            if (typeof pathOrObject === 'string') {
              navigate(pathOrObject, { state: deprecatedState });
            } else {
              // pathOrObject é um objeto { pathname, state }
              navigate(pathOrObject.pathname, { state: pathOrObject.state });
            }
          },
          replace: (pathOrObject, deprecatedState) => {
            if (typeof pathOrObject === 'string') {
              navigate(pathOrObject, { replace: true, state: deprecatedState });
            } else {
              navigate(pathOrObject.pathname, { replace: true, state: pathOrObject.state });
            }
          },
          go: (n) => navigate(n),
          goBack: () => navigate(-1),
          goForward: () => navigate(1),
        }}
      />
    );
  }

  return ComponentWithRouterProp;
}
